<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            fullscreen
            >
                <div class="pdf-viewer">
                    <div class="controls">
                        <button @click="prevPage" :disabled="currentPage <= 1">
                            <v-icon color="white">mdi-chevron-left</v-icon>
                            {{ $t("message.common.previous") }}
                        </button>
                        <span>{{ $t("message.common.page") }} {{ currentPage }} / {{ numPages }}</span>
                        <button @click="nextPage" :disabled="currentPage >= numPages">
                            {{ $t("message.common.next") }}
                            <v-icon color="white">mdi-chevron-right</v-icon>
                        </button>
                        <input 
                            type="number" 
                            v-model.number="currentPage" 
                            :min="1" 
                            :max="numPages"
                        />
                        <button @click="download">
                            <v-icon color="white">mdi-download</v-icon>
                            {{ $t("message.common.download") }}
                        </button>
                        <button class="button-red" @click="close">
                            <v-icon color="white">mdi-close</v-icon>
                            {{ $t("message.common.close") }}
                        </button>
                    </div>                    
                    <div class="pdf-container">
                        <vue-pdf-embed
                            annotation-layer
                            text-layer
                            :source="pdfUrl"
                            :page="currentPage"
                            :height="windowHeight"
                            @password-requested="handlePasswordRequest"
                            @loaded="handleDocumentLoad"
                            @rendered="handleDocumentRender"
                        />
                    </div>
                </div>
        </v-dialog>
    </v-row>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import * as services from "@/services";
import { getFileExtensionFromUrl } from "@/utils/extension";
import { getContentType } from "@/utils/contentType";

export default {
    name: 'PdfViewer',
    components: {
        VuePdfEmbed,
    },
    data() {
        return {
            isLoading: false,
            dialog: false,
            file: null,
            currentPage: 1,
            numPages: 0,
            pdfUrl: null,
            windowHeight: window.innerHeight
        }
    },
    methods: {
        getPdf(file) {
            this.file = file
            this.pdfUrl = this.file?.url
            this.dialog = true
        },
        nextPage() {
            if (this.currentPage < this.numPages) {
                this.currentPage++
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--
            }
        },
        handleDocumentLoad({numPages}) {
            this.numPages = numPages
        },
        handleDocumentRender() {
            this.isLoading = false
        },
        handlePasswordRequest({callback, isWrongPassword}) {
            callback(prompt(isWrongPassword ?
                'Enter password again' :
                'Enter password'
            ))
        },
        upload(event) {
            const file = event.target.files[0]
            if (file && file.type === 'application/pdf') {
                this.pdfUrl = URL.createObjectURL(file)
            }
        },
        async download() {
            try {
                const res = await services.downloadFile({
                    file_name: this.file?.name,
                    file_url: this.file?.url,
                });
                const extension = getFileExtensionFromUrl(this.file?.url);
                const blob = new Blob([res.data], {
                    type: getContentType(extension),
                });
                const downloadUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.target = "_blank";
                a.href = downloadUrl;
                a.download = this.file?.name;
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(downloadUrl);
            } catch (error) {
                console.error('Error downloading PDF:', error)
                this.$toast.error(this.$t('message.common.downloadError'));
            }
        },
        close() {
            this.dialog = false
            this.file = null
            this.pdfUrl = null
        }
    },
}
</script>

<style scoped lang="scss">
.pdf-viewer {
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
}
.controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 10px;
    background: #f5f5f5;
    border-radius: 4px;
}
.button-red {
    background: #ee0707 !important;
}
.controls button {
    font-family: 'Sarabun', sans-serif;
    font-size: 16px;
    padding: 8px 16px;
    background: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.controls button:disabled {
    background: #ccc;
    cursor: not-allowed;
}
.controls input {
    width: 60px;
    padding: 5px;
    text-align: center;
    border: 1px solid #ddd;
    border-radius: 4px;
}
.controls span {
    font-weight: 500;
}
.pdf-container {
    border: 1px solid #ddd;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    overflow: auto;
    background: #525659;
    display: flex;
    justify-content: center;
    padding: 20px;
}
</style>